import * as React from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { useNavigate } from 'react-router-dom';

export default function TemporaryDrawer(props) {
  const {
    direction = 'left',
    open = false,
    listItems = [],
    title = '',
  } = props;

  const [state, setState] = React.useState({
    top: false,
    left: false,
    bottom: false,
    right: false,
  });

  const navigate = useNavigate();

  React.useEffect(() => {
    setState({ [direction]: open });
  }, [open, direction]);

  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event.type === 'keydown' &&
      (event.key === 'Tab' || event.key === 'Shift')
    ) {
      return;
    }

    setState({ ...state, [anchor]: open });
    props.handleCloseNavMenu(false);
  };
  toggleDrawer(direction, true);

  const list = (anchor) => (
    <Box
      sx={{ width: anchor === 'top' || anchor === 'bottom' ? 'auto' : 250 }}
      role="presentation"
      onClick={toggleDrawer(anchor, false)}
      onKeyDown={toggleDrawer(anchor, false)}
    >
      <ListItem disablePadding>
        <ListItemButton
          onClick={() => {
            navigate('/');
          }}
        >
          <ListItemText primary={title} />
        </ListItemButton>
      </ListItem>
      <Divider />
      <List>
        {listItems.map((text, index) => (
          <div>
            <ListItem key={text} disablePadding>
              <ListItemButton
                onClick={() => {
                  navigate(text.path);
                }}
              >
                <ListItemIcon>{text.icon}</ListItemIcon>
                <ListItemText primary={text.name} />
              </ListItemButton>
            </ListItem>
          </div>
        ))}
      </List>
    </Box>
  );

  return (
    <div>
      {
        <>
          {
            <Drawer
              anchor={direction}
              open={state[direction]}
              onClose={toggleDrawer(direction, false)}
            >
              {list(direction)}
            </Drawer>
          }
        </>
      }
    </div>
  );
}
